import * as tslib_1 from "tslib";
import { Base } from '../base-component';
import './article-page-image-carousel-item.component.scss';
var ArticlePageImageCarouselItem = /** @class */ (function (_super) {
    tslib_1.__extends(ArticlePageImageCarouselItem, _super);
    function ArticlePageImageCarouselItem(element) {
        return _super.call(this, element) || this;
    }
    ArticlePageImageCarouselItem.prototype.init = function () { };
    ;
    ArticlePageImageCarouselItem.prototype.bindEvents = function () { };
    ;
    return ArticlePageImageCarouselItem;
}(Base));
export { ArticlePageImageCarouselItem };



//////////////////
// WEBPACK FOOTER
// ./components/article-page-image-carousel-item/article-page-image-carousel-item.component.ts
// module id = 103
// module chunks = 0